/** Apply saved review state when reopening an already-rated case. */

import type { ArtefactRatings, PhaseRatings, ReviewRecord, AgentRun } from "./types";
import { artefactRatingsFromReview, phaseRatingsFromReview } from "./reviewHydration";
import { type WizardStep } from "./wizardSteps";

export interface ResumedWizardState {
  step: WizardStep;
  ratings: PhaseRatings;
  artefactRatings: ArtefactRatings;
  intentConfirmed: boolean;
  reviewId: string;
}

export function resumeWizardState(
  existingReview: ReviewRecord,
  hasArtefacts: boolean,
  artefactIds: string[] = [],
  run?: AgentRun | null,
): ResumedWizardState {
  return {
    step: "submit",
    ratings: phaseRatingsFromReview(existingReview),
    artefactRatings: artefactRatingsFromReview(existingReview, artefactIds, run),
    intentConfirmed: true,
    reviewId: existingReview.review_id,
  };
}
